import React from 'react';

const VCPricingSection = () => (
    <section className="lp-vc-pricing">
        <div className="lp-container">
            <h2 className="lp-h2" style={{ textAlign: 'center', margin: '0 auto 52px', maxWidth: 'none' }} data-lp-reveal>What does it cost?</h2>
            <div className="lp-vc-pricing-grid">
                <div className="lp-vc-price-card" data-lp-reveal>
                    <div className="label">VC Firm</div>
                    <div className="price" style={{ color: '#FC7785' }}>Free</div>
                    <p>No platform fees, no licence costs, no commitment. Investor access is always free on Diligentsia.</p>
                </div>
                <div className="lp-vc-price-card lp-vc-price-card--paid" data-lp-reveal data-lp-delay="100">
                    <div className="label">Portfolio / Applicant Company</div>
                    <div className="price">£999<span>/ year</span></div>
                    <p>Portfolio company rate: £800/year (20% off via your firm). Companies bear the cost — not your firm.</p>
                    <a href="#">Full pricing →</a>
                </div>
            </div>
        </div>
    </section>
);

export default VCPricingSection;
